import React, { useEffect } from "react";
import { useState } from "react";
import serviceBanner from "../../assets/images/services/serviceBanner.png";
import customizationImg from "../../assets/images/services/customization.png";
import bridalImg from "../../assets/images/services/bridal.png";
import jewelleryImg from "../../assets/images/services/jewellery.png";
import virtualImg from "../../assets/images/services/virtual.png";
import footwearImg from "../../assets/images/services/footwear.png";
import star from "../../assets/images/sarees/star.png";
import sareeImg1 from "../../assets/images/sarees/saree-img1.png";
import sareeImg2 from "../../assets/images/sarees/saree-img2.png";
import { Mail } from "../../components/Mailbox";
import { Link, useNavigate } from "react-router-dom";
import { axiosInstance } from "../../axiosInstance";


export function Services() {
  // const [product, setProduct] = useState([]);
  // const navigate = useNavigate();

  //  async function LoadProducts() {
  //      const RequestMethod = {
  //        type: "1",
  //        price_min: "",
  //        price_max: "",
  //        availability: "",
  //        pageNo: 1,
  //      };

  //      try {
  //        const response = await axiosInstance.post(
  //          "/clothingByType",
  //          RequestMethod
  //        );
  //        console.log("saree data", response.data);
  //        setProduct(response.data.data || []);

  //      } catch (error) {
  //        console.error("Error loading products:", error);
  //      }
  //    }
  // useEffect(()=>{
  //   LoadProducts();
  // },[])

  
  return (
    <div className="HomeMainContainer container">
      <div className="service-banner">
        <div>
          <div className="service-bannerTitle">SERVICES</div>
          <div className="service-bannerDesc">
            Explore our range of services designed to enhance your shopping
            experience and bring your fashion vision to life
          </div>
        </div>
      </div>
      {/* Categories section */}
      <div>
        <div className="Customization-container">
          <div className="customizationImg">
            <img src={customizationImg} />
          </div>
          <div className="customization-content">
            <div className="customization-title">Customization & Tailoring</div>
            <div className="customization-subtitle">
              Experience the luxury of perfectly fitted clothing with our
              customization and tailoring services. From initial measurements to
              final fitting, we ensure your garments are tailored to your unique
              preferences and style.
            </div>
            <div>
              <ul className="customization-list">
                <li>Personalized Fit</li>
                <li>Fabric and Design Options</li>
                <li>Customer Showcase</li>
                <li>Care Tips</li>
              </ul>
            </div>
            <div className="btnServiceContact">
              <Link to="/contact">
                {" "}
                <button>Contact Us</button>
              </Link>
            </div>
          </div>
        </div>

        <div className="Bridal-container">
          <div className="bridal-content">
            <div className="Bridal-title">Bridal Dresses</div>
            <div className="Bridal-subtitle">
              Celebrate your special day with our exquisite bridal collection,
              crafted to make you feel radiant and confident. Our gowns are
              designed with intricate details and high-quality fabrics to ensure
              you shine on your wedding day.
            </div>
            <div>
              <ul className="Bridal-list">
                <li>Designer Spotlights</li>
                <li>Real Wedding Stories</li>
                <li>Styling Advice</li>
                <li>Customization Options</li>
              </ul>
            </div>
            <div className="btnServiceContact">
              <Link to="/contact">
                {" "}
                <button>Contact Us</button>
              </Link>
            </div>
          </div>
          <div className="bridalImg">
            <img src={bridalImg} />
          </div>
        </div>

        <div className="Customization-container">
          <div className="customizationImg">
            <img src={jewelleryImg} />
          </div>
          <div className="customization-content">
            <div className="customization-title">Handcrafted Jewelry</div>
            <div className="customization-subtitle">
              Discover the artistry behind our handcrafted jewelry collection,
              where each piece is meticulously crafted by skilled artisans. Our
              designs blend tradition with modern aesthetics, offering unique
              accessories that tell a story.
            </div>
            <div>
              <ul className="customization-list">
                <li>Artisan Stories</li>
                <li>Care Guides</li>
                <li>Styling Tips</li>
                <li>Customer Testimonials</li>
              </ul>
            </div>
            <div className="btnServiceContact">
              <Link to="/contact">
                {" "}
                <button>Contact Us</button>
              </Link>
            </div>
          </div>
        </div>

        <div className="Bridal-container">
          <div className="bridal-content">
            <div className="Bridal-title">Virtual Styling Sessions</div>
            <div className="Bridal-subtitle">
              Elevate your fashion journey with our virtual styling sessions,
              offering personalized advice tailored to your unique style and
              needs. Our expert stylists guide you through the latest trends and
              help you curate a wardrobe that reflects your personality.
            </div>
            <div>
              <ul className="Bridal-list">
                <li>Expert Stylists</li>
                <li>Trend Reports</li>
                <li>Success Stories</li>
                <li>Easy Booking</li>
              </ul>
            </div>
            <div className="btnServiceContact">
              <Link to="/contact">
                {" "}
                <button>Contact Us</button>
              </Link>
            </div>
          </div>
          <div className="bridalImg">
            <img src={virtualImg} />
          </div>
        </div>

        <div className="Customization-container">
          <div className="customizationImg">
            <img src={footwearImg} />
          </div>
          <div className="customization-content">
            <div className="customization-title">Footwear</div>
            <div className="customization-subtitle">
              Step into comfort and style with our footwear collection, designed
              to support your lifestyle while keeping you on-trend. Our shoes
              combine premium materials with innovative design for lasting
              wear.Our shoes combine premium materials with innovative design
              for lasting wear.
            </div>
            <div>
              <ul className="customization-list">
                <li>Comfort and Design</li>
                <li>Size and Fit Guide</li>
                <li>Behind the Scenes</li>
                <li>Seasonal Trends</li>
              </ul>
            </div>
            <div className="btnServiceContact">
              <Link to="/contact">
                {" "}
                <button>Contact Us</button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* cards part */}
      {/* <div className="subcard-title">You May Also Like</div>
             <div className="subcategory-cards-part">
  <div className="subcategory-cards">
    {product.map((productItem) => (
      <div className="saree-sub-card" key={productItem.id}>
        <div
          className="saree-card-image"
          style={{
            backgroundImage: `url(${productItem.image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "100%",
            height: "90%",
            transition: "background-image 0.3s ease-in-out",
            position: "relative",
            borderRadius: "8px",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundImage = `url(${productItem.image_two})`;
            e.currentTarget.querySelector(".saree-btnContainer").style.display = "flex";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundImage = `url(${productItem.image})`;
            e.currentTarget.querySelector(".saree-btnContainer").style.display = "none";
          }}
        >
          <div className="saree-btnContainer">
          <button
                  className="sree-hoverBtn"
                  onClick={() => {
                    navigate("/sareesubcategory", {
                      state: { Details: product },
                    });
                  }}
                >
                  Add To Cart
                </button>
          </div>
        </div>
        <div className="saree-card-title">{productItem.product_name}</div>
        <div className="saree-card-price">
          <span>₹ {productItem.price}</span>
          <span style={{ float: "right" }} className="saree-rate">
            <img src={star} alt="Rating" />
            {productItem.average_rating}
          </span>
        </div>
      </div>
    ))}
  </div>
</div> */}

      {/* MailContainer */}
      <Mail />
    </div>
  );
}
